document.addEventListener('DOMContentLoaded', () => {
  const openerItems = document.querySelectorAll('.main-navigation_dropdown-opener, .dropdown-component_opener');

  openerItems.forEach(opener => {
    opener.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const parentDropdownComponent = opener.closest('dropdown-component') || opener.parentElement;
      if (!parentDropdownComponent) return;

      const dropdownEl = parentDropdownComponent.querySelector(
        '.dropdown-component_wrapper, .dropdown-component_content'
      );
      if (!dropdownEl) return;

      const isOpen = dropdownEl.classList.contains('is-open');

      const level = opener.closest('li');
      const parentList = level ? level.closest('ul') : null;
      if (parentList) {
        parentList.querySelectorAll('.dropdown-component_wrapper.is-open, .dropdown-component_content.is-open').forEach(openMenu => {
          if (openMenu !== dropdownEl) {
            openMenu.classList.remove('is-open');
            const btn = openMenu.closest('dropdown-component')?.querySelector('.dropdown-component_opener');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      dropdownEl.classList.toggle('is-open', !isOpen);
      opener.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('dropdown-component') && !e.target.closest('.main-navigation_dropdown-opener')) {
      document.querySelectorAll('.dropdown-component_wrapper.is-open, .dropdown-component_content.is-open').forEach(menu => {
        menu.classList.remove('is-open');
      });
      document.querySelectorAll('.dropdown-component_opener[aria-expanded="true"]').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  });
});

// PFAND-TELEPORTATION & ACCORDIONS
function teleportPfand() {
  const taxElement = document.querySelector('.product_tax');
  const pfandBox = document.getElementById('updatesafe-pfand-container');
  if (taxElement && pfandBox) {
    if (taxElement.nextSibling !== pfandBox) {
      taxElement.parentNode.insertBefore(pfandBox, taxElement.nextSibling);
      pfandBox.style.display = 'block';
    }
  }
}

function initDescriptionAccordions() {
  const descContainer = document.querySelector('.main-product_description-block');
  if (!descContainer) return;
  const headings = descContainer.querySelectorAll('h5');
  headings.forEach(heading => {
    if (heading.dataset.accordionInit) return;
    if (heading.textContent.trim() === "") return;
    heading.dataset.accordionInit = "true";
    heading.classList.add('description-accordion-title');
    let siblings = [];
    let next = heading.nextElementSibling;
    while (next && next.tagName !== 'H5') {
      siblings.push(next);
      next = next.nextElementSibling;
    }
    siblings.forEach(el => el.style.display = 'none');
    heading.addEventListener('click', () => {
      heading.classList.toggle('is-open');
      siblings.forEach(el => { el.style.display = el.style.display === 'none' ? '' : 'none'; });
    });
  });
}

// Gemeinsame Initialisierung
document.addEventListener('DOMContentLoaded', () => {
    teleportPfand();
    initDescriptionAccordions();
});

if (document.body) {
  const mainObserver = new MutationObserver(() => {
    teleportPfand();
    initDescriptionAccordions();
  });
  mainObserver.observe(document.body, { childList: true, subtree: true });
}